import { uniq } from 'lodash';

export const getAllYears = posts => {
  const postsYears = posts.map(({ data: { date } }) => new Date(date).getFullYear());
  return uniq(postsYears).sort((a, b) => parseInt(b, 10) - parseInt(a, 10));
};
